// extracted by mini-css-extract-plugin
export default {"fullBtn":"header_fullBtn__Jd8i5","outBtn":"header_outBtn__N+hJV","title":"header_title__cS2b1"};